/* eslint-disable no-console */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { arrayOf, bool, func, node, oneOfType, shape, string, } from 'prop-types';
import setClass from '../../common/set-class';
function getCount(arr) {
    return arr.filter(({ all }) => !all).length;
}
export function allOptions(options, selected) {
    return getCount(options) === getCount(selected);
}
function ChipSelect({ options, setSelected, selected, classes, keepSelectedResponsive, disabled, testId, }) {
    const usedValues = [];
    const allCount = options.filter(({ all }) => all).length;
    if (+allCount > 1) {
        console.error(`Error: encountered ${allCount} options marked as "all" in ChipSelect; "all" will be omitted`);
    }
    const hasAll = allCount === 1;
    const allAreSelected = hasAll && allOptions(options, selected);
    return (React.createElement("div", { className: setClass([
            'b-chip-select__root',
            classes?.root,
            disabled ? 'b-not-allowed' : '',
        ]), "data-testid": testId }, options.map(({ value, label, onSelect, all }, idx) => {
        if (!(hasAll && all) && value === undefined) {
            console.error('Error: encountered an option in ChipSelect with no value that\'s not marked as "all"; skipping this option');
            return null;
        }
        if (usedValues.includes(value)) {
            console.error(`Error: encountered several options with the same value = ${value} in ChipSelect; skipping the one with label = ${label}`);
            return null;
        }
        usedValues.push(value);
        const isSelected = Array.isArray(selected)
            ? (all && allAreSelected) ||
                (!allAreSelected && selected.includes(value))
            : selected === value;
        return (React.createElement("div", { "data-testid": `option_${idx + 1}`, onClick: (event) => {
                if (disabled) {
                    return;
                }
                setSelected({ value, label, all: hasAll && all });
                if (onSelect) {
                    onSelect({ event, value, label, all: hasAll && all });
                }
            }, className: setClass([
                'b-chip-select__chip',
                'b-txt',
                classes?.chip,
                isSelected && 'b-chip-select__selected-chip',
                isSelected &&
                    !keepSelectedResponsive &&
                    'b-chip-select--no-pointer',
                isSelected && classes?.selected,
            ]), key: value || 'All' }, label || value || 'All'));
    })));
}
ChipSelect.propTypes = {
    options: arrayOf(shape({
        value: string,
        label: node,
        onSelect: func,
        all: bool,
    })).isRequired,
    setSelected: func,
    selected: oneOfType([string, arrayOf(string)]),
    classes: shape({
        root: string,
        selected: string,
        chip: string,
    }),
    keepSelectedResponsive: bool,
    disabled: bool,
    testId: string,
};
ChipSelect.defaultProps = {
    setSelected: null,
    selected: [],
    classes: null,
    keepSelectedResponsive: false,
    disabled: false,
    testId: undefined,
};
export default ChipSelect;
